<template>

<div class="wrapper">
	stuff here
</div>

</template>

<script>
export default {
	name: 'merge-customers',
    components: {
    },
	data() {
		return {
            loading: true
        }
    },
    created() {
		this.getFilterLists()
		this.clearFilters(true)
	},
    computed: {
    },
	watch: {
	},
	methods: {
    }
}
</script>

<style lang="scss" scoped>
</style>
